function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from '../utils/create';
import { props } from './props';
import { get, getQuery, getGlobalParams } from '@changba/funny';
import CbRank from '../rank';
import CbTabs from '../tabs';
import CbTab from '../tab';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "rank-tabs"
  }, [_c('CbTabs', _vm._b({
    on: {
      "change": _vm.handleTabChange
    },
    model: {
      value: _vm.currentTab,
      callback: function ($v) {
        _vm.currentTab = $v;
      },
      expression: "currentTab"
    }
  }, 'CbTabs', _vm.innerTabsConfig, false), _vm._l(_vm.calcTabs, function (tab) {
    return _c('CbTab', _vm._b({
      key: tab.name,
      attrs: {
        "name": tab.name,
        "active-background": tab.backgroundImage
      }
    }, 'CbTab', tab, false), [_c('div', {
      staticClass: "tab-item-wrapper"
    }, [!_vm.$slots[tab.name + '-header'] && !tab.noHeader ? _vm._t("header") : _vm._e(), _vm._v(" "), !tab.noHeader ? _vm._t(tab.name + '-header') : _vm._e(), _vm._v(" "), !_vm.$scopedSlots[tab.name + '-rank'] ? _vm._t("rank", function () {
      return [_c('CbRank', _vm._b({
        attrs: {
          "rank-list": _vm.getRankDataList(tab.name),
          "own": _vm.getRankOwnData(tab.name)
        }
      }, 'CbRank', _vm.getTabRankConfig(tab.name), false))];
    }, {
      "rankList": _vm.getRankDataList(tab.name),
      "own": _vm.getRankOwnData(tab.name)
    }) : _vm._e(), _vm._v(" "), _vm.$scopedSlots[tab.name + '-rank'] ? _vm._t(tab.name + '-rank', function () {
      return [_c('CbRank', _vm._b({
        attrs: {
          "rank-list": _vm.getRankDataList(tab.name),
          "own": _vm.getRankOwnData(tab.name)
        }
      }, 'CbRank', _vm.getTabRankConfig(tab.name), false))];
    }, {
      "rankList": _vm.getRankDataList(tab.name),
      "own": _vm.getRankOwnData(tab.name)
    }) : _vm._e()], 2)]);
  }), 1)], 1);
};
var staticRenderFns = [];
export default defineComponent({
  _scopeId: 'data-v-c3c7d0a8',
  render,
  name: 'CbRankTabs',
  props,
  components: {
    CbRank,
    CbTab,
    CbTabs
  },
  data() {
    return {
      currentTab: '',
      dataSet: {},
      map: new Map()
    };
  },
  watch: {
    active: {
      handler(nextTab, preTab) {
        if (nextTab && nextTab !== preTab) {
          this.currentTab = nextTab;
        }
      },
      immediate: true
    },
    tabs: {
      handler(nextTabs) {
        var tabs = Array.isArray(nextTabs) ? nextTabs : Object.entries(this.tabs).map(_ref => {
          var [prop, config] = _ref;
          return _extends({
            name: prop
          }, config);
        });
        tabs.forEach(tab => {
          if (!this.map.get(tab.name)) {
            this.map.set(tab.name, tab);
          }
        });
      },
      immediate: true
    }
  },
  computed: {
    activeRankId() {
      var currentTabConfig = this.map.get(this.currentTab);
      return currentTabConfig ? currentTabConfig.rankId : null;
    },
    calcTabs() {
      return Array.isArray(this.tabs) ? this.tabs : Object.entries(this.tabs).map(_ref2 => {
        var [prop, config] = _ref2;
        return _extends({
          name: prop
        }, config);
      });
    },
    calcRankParams() {
      // 每个对象上有一个key且仅有一个key，否则视为一个对象配所有的配置
      return Array.isArray(this.tabRankParams) ? this.tabRankParams : Object.entries(this.tabRankParams).map(_ref3 => {
        var [name, options] = _ref3;
        return _extends({
          name
        }, options);
      });
    }
  },
  mounted() {
    if (this.immediate) {
      this.getRankList();
    }
  },
  methods: {
    isIndividualConfig() {
      return Array.isArray(this.tabRankConfig) || Object.values(this.tabRankConfig || {}).length > 0 && Object.values(this.tabRankConfig || {}).every(v => {
        return typeof v === 'object' && v !== null;
      });
    },
    getRankList() {
      var _this = this;
      return _asyncToGenerator(function* () {
        var resp = yield _this.getServerData();
        var own = resp.own || {};
        var rankList = resp.rankList || [];
        if (!_this.dataSet[_this.currentTab]) {
          _this.$set(_this.dataSet, _this.currentTab, {
            own,
            rankList
          });
        } else {
          _this.dataSet[_this.currentTab].own = own;
          _this.dataSet[_this.currentTab].rankList = rankList;
        }
      })();
    },
    getServerData() {
      var _this2 = this;
      return _asyncToGenerator(function* () {
        var currentTabConfig = _this2.map.get(_this2.currentTab);
        if (typeof _this2.requestData === 'function') {
          return _this2.requestData(currentTabConfig);
        }
        var response = {
          own: {},
          rankList: []
        };
        var isRoomType = currentTabConfig.type === 'room' || _this2.tabRankConfig.type === 'room';
        var sendData = {
          rankId: _this2.activeRankId
        };
        if (isRoomType) {
          sendData.roomid = getQuery('roomId');
          if (!sendData.roomid) {
            var _params$ktvRoomStats;
            var params = yield getGlobalParams();
            sendData.roomid = (_params$ktvRoomStats = params.ktvRoomStats) == null ? void 0 : _params$ktvRoomStats.room_id;
          }
        }
        var isPreview = ['site-prod', 'site-dev'].includes(process.env.NODE_ENV) || getQuery('isMock');
        var url = isPreview ? 'https://yapi.changbaops.com/mock/32/www/api/v1/rank/list' : window.BFF_HOST + "/api/v1/rank/list/" + _this2.actId;
        var resp = yield get({
          url,
          data: sendData,
          ignoreBaseURL: true
        });
        if (resp.code === 0) {
          response.own = resp.data.own;
          response.rankList = resp.data.list;
        } else {
          _this2.toast(resp.msg || '获取榜单数据失败，请稍后再试试吧~');
        }
        return response;
      })();
    },
    getTabData(tabName, prop) {
      var dataSet = this.dataSet[tabName] || {};
      return dataSet[prop];
    },
    getTabRankConfig(tabName) {
      // 是否是单独针对每个榜单的配置
      var isConfigForSingle = this.isIndividualConfig();
      if (!isConfigForSingle) {
        return this.tabRankConfig || {};
      }
      // 针对每个对象的配置
      if (this.tabRankConfig[tabName]) {
        return this.tabRankConfig[tabName] || {};
      }
      // 采用数组的配置
      return Array.isArray(this.tabRankConfig) ? this.tabRankConfig.find(tab => tab.name === tabName) || {} : {};
    },
    getRankDataList(tabName) {
      return this.getTabData(tabName, 'rankList') || [];
    },
    getRankOwnData(tabName) {
      return this.getTabData(tabName, 'own') || {};
    },
    handleTabChange(nextTab) {
      var nextTabConfig = this.map.get(nextTab);
      if (!nextTabConfig) {
        return;
      }
      this.currentTab = nextTab;
      // 触发事件，以供埋点处理
      this.$emit('tab-click', nextTab);
      // 如果当前高亮的Tab不需要请求数据
      if (!nextTabConfig.withoutRequest) {
        this.getRankList();
      }
    },
    toast(msg) {
      if (typeof this.$toast === 'function') {
        this.$toast(msg);
      } else if (typeof this.$Toast === 'function') {
        this.$Toast(msg);
      } else {
        alert(msg);
      }
    }
  }
});